import * as actionTypes from "./actionTypes";
const initialState = {
  country: "",
  loader: false,
  person: {
    name_prefix: "Mr.",
    first_name: "",
    last_name: "",
    gender: "m",
    passport_name: "",
    passport_number: "",
    dob: "",
    address: "",
    permanent_address: "",
    mobile_number: "",
    email: "",
    home_number: "",
    guardian_mobile_number: "",
    country: "",
    nationality: "",
    education: [
      {
        title: "",
        institute: "",
        attended_from: "",
        attended_to: "",
        percentage: "",
      },
    ],
    documents: [],
  },
  contries: [],
  social_links :{},
  bannerImages :[]
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_COUNTARY":
      return {
        ...state,
        country: action.name,
      };
    case "SET_PERSON":
      return {
        ...state,
        person: {
          ...state.person,
          ...action.person,
        },
      };

    case "SET_LOADER":
      return {
        ...state,
        loader: !state.loader,
      };
    case "SET_INPUT":
      const value = action.event.target.value;
      return {
        ...state,
        person: {
          ...state.person,
          [action.event.target.name]: value,
        },
      };
    case "SET_EDUCATION":
      let index = action.event.target.getAttribute("index");
      let educateForm = [...state.person.education];
      let user = {
        ...educateForm[index],
        [action.event.target.name]: action.event.target.value,
      };
      educateForm[index] = user;
      return {
        ...state,
        person: {
          ...state.person,
          education: educateForm,
        },
      };
    case "ADD_EDUCATION":
      const education = {
        title: "",
        institute: "",
        attended_from: "",
        attended_to: "",
        percentage: "",
      };
      let educationForm = state.person.educateForm;
      educationForm.push(education);
      return {
        ...state,
        person: {
          ...state.person,
          education: educationForm,
        },
      };
    case "FILE_HANDLER":
      state.person.documents = [];
      let data = state.person.documents;
      action.dataFile.forEach((file) => {
        getBase64(file).then((response) => {
          data.push(response);
        });
      });
      return {
        ...state,
        person: {
          ...state.person,
          documents: data,
        },
      };
    case actionTypes.FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        contries: action.contries.data,
        social_links: action.contries.social_links,
      };
    case actionTypes.FETCH_BANNERIMAGES_SUCCESS:
      return {
        ...state,
        bannerImages: action.bannerImages
      };
  }
  return state;
};

export default reducer;

const getBase64 = (file) => {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(reader.result);
    };
  });
};
